<template>
    <v-dialog v-model="dialog" persistent max-width="500">
        <v-img 
            :src="require('@/assets/img/icons/icon-bulb.png')"
            class="dialog-icon"
            height="80"
            width="80"
            />

        <v-card class="d-flex flex-column justify-center align-center">
            <div
                class="d-flex flex-column justify-center align-center border-radius-1"
            >
                <div class="pa-5 mx-5 mt-2">
                    <span class="text-h6 white--text pa-5 font-weight-lighter">
                        {{ tipTitle }}
                    </span>
                </div>
                <div class="px-5 mx-5">
                    <span class="white--text text-body-1">
                        {{ tip_text }}
                    </span>
                </div>
                <v-card-actions class="w-100 d-flex justify-center align-center py-6">
                    <v-row class="ma-0">
                        <v-col cols="12" md="10" offset-md="1">
                            <v-btn color="white" class="px-16 py-5 border-radius-1" block outlined @click="close">
                                {{ $t('bookReading.understood') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        dialog: { type: Boolean, default: false },
        tip_number: { type: [String, Number], default: '' },
        total_tips: { type: [String, Number], default: '' },
        tip_text: { type: [String, Number], default: '' },
    },
    data() {
        return {
            pistaImg: require('@/assets/img/gamifications/desafios-pista.svg'),
        }
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
    },
    computed: {
        tipTitle() {
            return `${this.$t('bookReading.clue')} ${this.tip_number} ${this.$t('of')} ${
                this.total_tips
            }`
        },
    },
}
</script>
<style>
.p-img {
    z-index: 300;
}
.p-img img {
    height: 20vh;
}
.pistas-content {
    border-radius: 26px;
    background: linear-gradient(180deg, #6f5fa4 0%, #261c48 100%);
}
.items-unset {
    align-items: unset !important;
}
</style>
